import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={{ opacity: 0, y: reduce ? 0 : y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const SectionHead = ({ eyebrow, title, sub, align = "start" }) => (
  <Reveal className={align === "center" ? "text-center" : "text-start"}>
    <p className="text-xs uppercase tracking-[0.3em] text-gold font-semibold mb-4" data-testid={`${eyebrow ? "section-eyebrow" : ""}`}>
      {eyebrow}
    </p>
    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white leading-tight">
      {title}
    </h2>
    {sub && <p className="mt-5 text-base text-slate-400 leading-relaxed max-w-2xl">{sub}</p>}
  </Reveal>
);
